import { createBrowserHistory } from 'history';
import React, { FC, useState } from 'react';
import { Route, Switch, Redirect, Router } from 'react-router-dom';
import Login from '../pages/Login';
import forgotPassword from '../pages/Login/forgotPassword';
import changePassword from '../pages/Login/changePassword';
import InfomodulRouter from './infomodul';
import MobilbaseRouter from './mobilbase';
import GlobalSearchRouter from './globalSearch';
import UserManagementRouter from './usermanagement';
import LocationsRouter from './locations'
import StatsManagementRouter from './statistics';
import DoorOpenerRouter from './dooropener';
import ProtectedRoute from './ProtectedRoute';
import AlarmsRouter from './alarms'
import ParkingSolvisionRouter from './customermanagement'
import { userContext } from '../utils/userContext';
import { TokenStorage } from '../api/auth/TokenStorage';
import Permissions from '../api/auth/permissions'
import { SvgIcon, Icon } from '@material-ui/core'
import { ReactComponent as SvgAlarms } from './icons/alarms.svg'
import { ReactComponent as SvgCustomerAdministration } from './icons/customeradministration.svg'
import { ReactComponent as SvgDoorOpener } from './icons/dooropener.svg'
import { ReactComponent as SvgMobileBase } from './icons/mobilebase.svg'
import { ReactComponent as SvgStatistics } from './icons/statistics.svg'
import { ReactComponent as SvgUsers } from './icons/users.svg'
import { ReactComponent as SvgConfirmation } from './icons/confirmation.svg'
import DigitalLicensRouter from './digitalLicensRoute';

// setup for the different page cases
    const mobilBasePage = 0
    const usersPage = 1
    const spotAccessPage = 2
    const statsPage = 3
        const kreditCardsPage = 3.1
        const transactionPage = 3.2
        const coinEmpyingPage = 3.3
        const alarmsPage = 3.4
    const doorOpeningPage = 4 
    const SMSAlarmsPage = 5
    const customerAdmin = 6
    const digitalLicensPage = 7

    var url = ""
    var keyList = [""] // the var used for temporarily saving key presses

    const keyShortCuts = (page: number) => { // the case handler for url switching
        switch (page) {
        case mobilBasePage: 
            url = "/mobilbase/plads"
            break
        case usersPage: 
            url = "/usermanagement"
            break
        case spotAccessPage: 
            url = "/locations"
            break
        case statsPage: 
            url = "/statistics"
            break
        case kreditCardsPage: 
            url = "/statistics/cardtypes"
            break
        case transactionPage: 
            url = "/statistics/transactions"
            break
        case coinEmpyingPage: 
            url = "/statistics/emptying"
            break
        case alarmsPage:
            url = "/statistics/alarms"
            break 
        case doorOpeningPage: 
            url = "/dooropener"
            break
        case SMSAlarmsPage:
            url = "/alarms/groupings"
            break
        case customerAdmin:
            url = "/customermanagement/customers"
            break
        case digitalLicensPage:
            url = "/digital-license"
            break
        case 10: // All
            url = "/statistics/all"
            break
        default:
            // Does not make sense
            return
        }
        history.push(url, page)
    }

document.addEventListener('keydown', (event) => { // the document listener for user shortcut input
    const keyname = event.key
    keyList.push(keyname) // Save the key user key presses

    if (event.altKey && event.shiftKey && keyList.includes("M")) {
        keyShortCuts(0)
    }
    if (event.altKey && event.shiftKey && keyList.includes("B")) {
        keyShortCuts(1)
    }
    if (event.altKey && event.shiftKey && keyList.includes("P")) {
        keyShortCuts(2)
    }
    if (event.altKey && event.shiftKey && keyList.includes("S")){ 
        keyShortCuts(3)
    }
    if (event.shiftKey && keyList.includes("S") && keyList.includes("K")) { // next "three" -> Not including the ALT key due to possible shortcut conflict
        keyShortCuts(3.1)
    }
    if (event.shiftKey && keyList.includes("S") && keyList.includes("P") ) {
        keyShortCuts(3.2)
    }
    if (event.shiftKey && keyList.includes("S") && keyList.includes("M")) {
        keyShortCuts(3.3)
    }
    if (event.shiftKey && keyList.includes("S") && keyList.includes("A")) {
        keyShortCuts(3.4)
    } 
    if (event.altKey && event.shiftKey && keyList.includes("D")) {
        keyShortCuts(4)
    }
    if (event.altKey && event.shiftKey && keyList.includes("A")) {
        keyShortCuts(5)
    }
    if (event.altKey && event.shiftKey && keyList.includes("K")) {
        keyShortCuts(6)
    }
}, false)

document.addEventListener('keyup', () => { // used to clear the keyList when the user lifts a button press
    //const keyname = event.key
        keyList = [""]
}, false)

const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL
})

const BaseRouter: FC = () => {
    const [user] = useState({})

    const modules = [
        {
            permission: Permissions.Mobilbase,
            route: "/mobilbase",
            displayName: "Mobilbase",
            icon: <SvgIcon><SvgMobileBase/></SvgIcon>
        },
        {
            permission: Permissions.GlobalSearch,
            route: "/parkant-opslag",
            displayName: "Parkantopslag",
            icon: <Icon>search</Icon>
        },
        {
            permission: Permissions.InfoModule,
            route: "/infomodul",
            displayName: "Infomodul",
            icon: <Icon>info</Icon>
        },
        {
            permission: Permissions.UserManagement,
            route: "/usermanagement",
            displayName:"Brugere",
            icon: <SvgIcon><SvgUsers/></SvgIcon>
        },
        {
            permission: Permissions.UserManagement,
            route: "/locations",
            displayName:"Pladsadgang",
            icon: <Icon>map</Icon>
        },
        {
            permission: Permissions.Statistics,
            route: "/statistics",
            displayName:"Statistik",
            icon: <SvgIcon><SvgStatistics/></SvgIcon> // <SvgStatistics/>
        },
        {
            permission: Permissions.SMSDoorOpener,
            route: "/dooropener",
            displayName:"SMS døråbner",
            icon: <SvgIcon><SvgDoorOpener/></SvgIcon>
        },
        {
            permission: Permissions.Alarms,
            route: "/alarms",
            displayName: "SMS alarmer",
            icon: <SvgIcon><SvgAlarms/></SvgIcon>
        },
        {
            permission: Permissions.DigitalLicenses,
            route: "/digital-licens",
            displayName: "Digitale Licenser",
            icon: <SvgIcon><SvgConfirmation/></SvgIcon>
        },
        {
            permission: Permissions.CustomerManagement,
            route: "/customermanagement",
            displayName: "Kundeadministration",
            icon: <SvgIcon><SvgCustomerAdministration/></SvgIcon>
        }
    ];

    const hasModulePermission = (route: string) => {
        const access = TokenStorage.getModuleAccesses();
        var e;
        for (e of modules) {
            if (access.includes(e.permission) && e.route === route) {
                return true;
            }
        }
        return false;
    }

    return (
        <userContext.Provider value={{user: user, modules: modules, hasModule: hasModulePermission}}>
            <Router history={history}>
                <Switch>
                    <Route exact path={`/login`}> <Redirect to="/"/></Route>
                    <ProtectedRoute path={`/mobilbase`} component={MobilbaseRouter}/>
                    <ProtectedRoute path={`/parkant-opslag`} component={GlobalSearchRouter} />
                    <ProtectedRoute path={`/infomodul`} component={InfomodulRouter} />
                    <ProtectedRoute path={`/usermanagement`} component={UserManagementRouter} />
                    <ProtectedRoute path={`/locations`} component={LocationsRouter} />
                    <ProtectedRoute path={`/statistics`} component={StatsManagementRouter} />
                    <ProtectedRoute path={`/dooropener`} component={DoorOpenerRouter} />
                    <ProtectedRoute path={`/alarms`} component={AlarmsRouter} />
                    <ProtectedRoute path={`/customermanagement`} component={ParkingSolvisionRouter} />
                    <ProtectedRoute path={`/digital-licens`} component={DigitalLicensRouter} />
                    <Route path={`/unauthorized`} component={() => <div>Du har ikke adgang til denne side</div>}/>
                    <Route exact path="/" component={Login} />
                    <Route exact path={`/forgotPassword`} component={forgotPassword} />
                    <Route exact path={`/changePassword`} component={changePassword} />
                    <Route exact path="" > <Redirect to="/"/></Route>
                    <Route component={() => <div>Siden bliv ikke fundet</div>}/>
                </Switch>
            </Router>
        </userContext.Provider>

    );
}

export default BaseRouter;
